<template>
  <div class="contactUs_body">
    <div class="navbar_style">
      <Icon class="navbar_icon" name="arrow-left" @click="$router.back(1)"/>
      <span>{{ l.text_contact_us }}</span>
      <div class="icon_box"></div>
    </div>
    <div class="peoBox" v-if="conf">
      <div class="contact_item" v-if="conf.line">
        <div class="contact_item_ab" @click="codeAdd">
          <div class="contact_item_ab_box">
            <img class="contact_item_ab_img" src="@/assets/my/linecode.png" alt="">
            <div class="contact_item_ab_text">
              {{ l.my_setting__code_zalo_cust }}
            </div>
          </div>
        </div>
        <div class="contact_item_title">
          <img class="contact_item_img" src="@/assets/my/line.png" alt="">
          <div class="contact_item_title_right">
            <div class="contact_item_info">{{
                l.my_setting_line_cust
              }}
            </div>
            <div class="contact_item_info2">
              {{ conf.line }}
              <div class="contact_item_btn" v-if="conf.line" @click="linkTo(conf.line)">
                {{ l.text_copy }}
                <!--                <img src="@/assets/my/jump.png" alt="">-->
              </div>

            </div>
          </div>
        </div>
        <div class="contact_item_main">
        </div>
      </div>

    </div>
    <Popup position="center" :close-on-click-overlay="false" round v-model="showLineCode">
      <div class="popup_box">

        <div class="blocks">
          <div class="blocks_title">
            {{ l.my_setting_zalo_code_cust }}
          </div>
          <div class="blocks_img_box">
            <img class="blocks_img" :src="lineCode" alt="">
          </div>
          <div class="blocks_desc">
            {{ l.my_setting_zalo_dowl_cust }}
          </div>
        </div>

        <div class="btnBox">
          <Button
              @click="showLineCode = false"
              class="confirmLoanBtn"
              block
              type="info"
              native-type="submit"
          >{{ l.my_setting_zalo_close_cust }}
          </Button>
          <Button
              @click="downloadPic"
              class="confirmLoanBtn confirmLoanBtn2"
              block
              type="info"
              native-type="submit"
          >{{ l.my_setting_zalo_save_cust }}
          </Button>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
import {Icon, Toast, Popup, Button} from "vant";
import l from "../../locales";
import {config} from "@/services/user";
import QRCode from "qrcode";

export default {
  name: "personalData",
  components: {
    Icon,
    Popup,
    Button,
  },
  data() {
    return {
      l: {...l.common, ...l.my},
      conf: undefined,

      showLineCode: false,
      lineCode: "",
    };
  },
  created() {
    this.init();
  },
  methods: {
    downloadPic() {
      this.downloadIamge(this.lineCode, Date.now() + "_line.png");
    },
    downloadIamge(imgsrc, name) {
      let image = new Image();
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
        let a = document.createElement("a"); // 生成一个a元素
        let event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "海报"; // 设置图片名称没有设置则为默认
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    codeAdd() {
      this.showLineCode = true;
    },
    openPhone(str) {
      if (process.env.VUE_APP_GENRE === "nested") {
        this.$tools.androidMethod(
            "callService",
            {
              phone: str,
            },
            ""
        );
      } else {
        window.location.href = "tel:" + str;
      }
    },
    linkTo(str) {
      if (
          /^(((ht|f)tps?):\/\/)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/.test(
              str
          )
      ) {
        window.location.href = str;
      } else {
        const input = document.createElement("input");
        input.setAttribute("value", str);
        document.body.appendChild(input);
        input.select();
        document.execCommand("Copy");
        document.body.removeChild(input);
        Toast(this.l.bank_copy_suc);
      }
    },
    async init() {
      let conf = JSON.parse(localStorage.getItem("config") || "{}");
      if (!conf) {
        let res = await config();
        conf = res.result;
      }
      this.conf = conf;
      this.conf.line = conf.zalo_phone;

      QRCode.toDataURL(
          "https://lin.ee/"+this.conf.line,
          {
            margin: 0, // 留白为空
          }
      )
          .then((url) => {
            this.lineCode = url;
          })
          .catch((err) => {
            console.error("QRCode.toDataURL", err);
          });

      console.log("conf", conf);
    },
  },
};
</script>

<style lang="less" scoped>
.contactUs_body {
  height: 100%;
  min-height: 100vh;
  width: 100%;
  height: 100%;
  //background: url("../../assets/my/bgc.png") no-repeat #F7FCFF;
  //background-size: 100%;

  background: #F8FBFF;
}

.peoBox {
  margin: 0 auto;
  margin-top: 20px;
  box-sizing: border-box;
  width: calc(100% - 30px);
  //height: 339px;

  .contact_item {
    position: relative;
    overflow: hidden;
    margin-top: 20px;
    background: #FFFFFF;
    box-shadow: 0px 0px 5px 0px rgba(56, 151, 229, 0.2);
    border-radius: 10px;


    padding: 15px 20px;
    box-sizing: border-box;

    display: flex;
    align-items: center;
    justify-content: space-between;

    .contact_item_ab {
      position: absolute;
      top: 0;
      right: 0;

      .contact_item_ab_box {
        position: relative;
        height: 60px;

        .contact_item_ab_img {
          width: 52px;
          height: 45px;
        }

        .contact_item_ab_text {
          position: absolute;
          pointer-events: none;
          top:50%;
          left: calc(50% - 5px);
          transform: translate( -50%,-50%) rotate(41deg);
          //transform:  rotate(45deg);
          width: 60px;
          text-align: center;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 11px;
          color: #637D9F;
        }
      }
    }

    .contact_item_title {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #444444;
      line-height: 20px;
      margin-right: 20px;
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .contact_item_img {
        width: 34px;
        height: 34px;
        margin-right: 20px;
        //display: none;
      }

      .contact_item_title_right {
        .contact_item_info {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #28435B;
        }

        .contact_item_info2 {
          margin-top: 4px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #637D9F;
          letter-spacing: 3px;
          display: flex;
          align-items: center;
          justify-content: center;

          .contact_item_btn {
            background: rgba(0,144,194,0.1);
            border: 1px solid #0090C2;

            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 11px;
            color: #0090C2;

            border-radius: 16px;
            padding: 4px 11px;
            box-sizing: border-box;

            display: flex;
            align-items: center;
            justify-content: center;

            margin-left: 10px;
          }
        }
      }
    }

    .contact_item_main {
      //padding-bottom: 12px;
      //height: 44px;

      display: flex;
      align-items: flex-end;
      justify-content: flex-end;


      box-sizing: border-box;

      .contact_item_info {
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #373F47;
        line-height: 20px;
        text-align: right;
        margin-right: 10px;


        word-break: break-all;
        //overflow: hidden;
        //display: -webkit-box;
        //-webkit-line-clamp: 2;
        //-webkit-box-orient: vertical;
      }

      .contact_item_btn {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        img {
          width: 16px;
          height: 16px;
        }

      }

    }
  }

}

.popup_box {
  width: 255px;
  padding: 20px 0;
  box-sizing: border-box;
  background: #FFFFFF;
  border-radius: 15px;

  .blocks {
    padding-top: 20px;

    .blocks_title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 15px;
      color: #000000;
      text-align: center;
    }

    .blocks_img_box {
      margin: 20px;
      display: flex;
      align-items: center;
      justify-content: center;

      .blocks_img {
        width: 150px;
        height: 150px;
      }
    }

    .blocks_desc {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #666666;
      text-align: center;
    }
  }

  .btnBox {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .confirmLoanBtn {
      width: 86px;
      height: 30px;
      background: #EBEBEB;
      border-radius: 18px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 13px;
      color: #454545;

      border: none;
      outline: none;
      box-sizing: border-box;
    }

    .confirmLoanBtn2 {

      background: rgba(0,144,194,0.1);
      border: 1px solid #0090C2;
      color: #0090C2;
      margin-left: 13px;
    }
  }
}

</style>
